import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

class WaitDialog extends Component {

  render() {

    const {
      open,
      title,
      message
    } = this.props;

    return (
      <Dialog
        open={open}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Box sx={{ width: '100%' }}>
            <LinearProgress />
          </Box>
        </DialogActions>
      </Dialog>
    );
  }
}

WaitDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired
};

export default WaitDialog;
